import styled from "styled-components";
import Button from "../../../Button";
import { colors } from "../../../../utils";

export const Container = styled.div``;

export const Header = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  grid-gap: 8px;
`;

export const ColorsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 160px;
`;

export const CircleRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  position: relative;
  // dd
`;

export const CircleBorder = styled.div`
  position: absolute;
  width: 24px;
  height: 24px;
  overflow: hidden;
  border-radius: 50%;
  border: 1px solid #98a2b3;
  opacity: 1;
  right: ${(props) =>
    props.visible ? `${props.index * 34}px` : `${props.right}px`};
  transition: all 0.5s ease;
`;

export const Circle = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 50%;
`;

export const ModalContainer = styled.div`
  /* position: absolute; */
  /* top: 50%;
  left: 50%;
  transform: translate(-50%, -50%); */
  width: 90vw;
  max-width: 1200px;
  min-width: 320px;
  /* height: 80vh; */
  background-color: #ffffff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  display: flex;
  flex-direction: column;

  @media (min-width: 768px) {
    width: 80vw;
  }

  @media (min-width: 1024px) {
    width: 70vw;
  }

  @media (min-width: 1280px) {
    width: 60vw;
  }
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #ddd;
  padding: 24px 20px;
`;

export const ModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  border-top: 1px solid #ddd;
  padding: 24px 20px;
`;

export const ModalContent = styled.div`
  flex: 1;
  padding: 16px;
  overflow: hidden;
  display: flex;
  flex-direction: column;

  @media (min-width: 768px) {
    padding: 20px;
  }
`;

export const Grid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  flex: 1;
  min-height: 0; /* Allow flex children to shrink */

  @media (min-width: 768px) {
    display: grid;
    grid-template-columns: 280px 1fr;
    grid-gap: 24px;
  }

  @media (min-width: 1024px) {
    grid-template-columns: 320px 1fr;
    grid-gap: 28px;
  }

  @media (min-width: 1280px) {
    grid-template-columns: 360px 1fr;
  }
`;

export const PreviewContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 0;
  order: 2;
  flex: 1;
  min-height: 0; /* Allow flex children to shrink */

  @media (min-width: 768px) {
    margin-left: 5%;
    order: 1;
  }
`;

export const StylingContainer = styled.div`
  flex: 1;
  max-height: 48vh;
  overflow-y: auto;
  order: 1;
  min-height: 0; /* Allow flex children to shrink */
`;

export const ImageWrapper = styled.div`
  background-color: ${colors.background};
  padding: 8px;
  border-radius: 8px;
  margin-top: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
  min-height: 200px;
  width: 100%;

  /* Ensure the SVG scales properly */
  svg {
    max-width: 100%;
    max-height: 100%;
    height: auto;
    width: auto;
  }

  img {
    max-width: 100%;
    max-height: 100%;
    height: auto;
    object-fit: contain;
  }

  @media (min-width: 480px) {
    padding: 12px;
    margin-top: 16px;
    min-height: 220px;
  }

  @media (min-width: 768px) {
    padding: 12px 0px;
    margin-top: 20px;
    min-height: 240px;
  }

  @media (min-width: 1024px) {
    min-height: 280px;
  }
`;

export const ButtonsContainer = styled.div`
  display: grid;
  grid-template-columns: 80px 100px;
  grid-gap: 20px;
`;

export const LibraryButton = styled.div`
  background-color: ${colors.background};
  border-radius: 4px;
  display: grid;
  grid-template-columns: 18px 1fr;
  gap: 10px;
  padding: 5px 10px;
  cursor: pointer;
  justify-content: center;
  align-items: center;
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
`;

export const LoaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 30%;
`;

export const CenteredContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-top: 10%;
  gap: 20px;
`;

export const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 10px;
  margin-top: 10px;
`;

export const SidebarLayout = styled.div`
  display: grid;
  grid-template-columns: 180px 1fr;
  grid-gap: 20px;
`;
